import { c as _c } from "react/compiler-runtime";
import { formatNumber } from '@/util/i18n/format-number';
import { useMemo } from 'react';
// ort { useLocaleContext } from '../../providers/locale'

export interface FormatNumberProps extends Intl.NumberFormatOptions {
  /**
   * The number to format
   */
  value: number;
}
export const FormatNumber = props => {
  const $ = _c(4);
  const locale = "en-US";
  let t0;
  if ($[0] !== props) {
    const {
      value,
      ...intlOptions
    } = props;
    t0 = formatNumber(value, "en-US", intlOptions);
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const text = t0;
  let t1;
  if ($[2] !== text) {
    t1 = <>{text}</>;
    $[2] = text;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
FormatNumber.displayName = 'FormatNumber';